export const mutations = {
  STORE_TRUCKS(state, trucks) {
    state.trucks = trucks;
  },
  STORE_TRUCK(state, truck) {
    state.truck = truck;
  },

  STORE_TRUCK_ALLOCATIONS(state, truckallocations) {
    state.truckallocations = truckallocations;
  },

  STORE_TRUCK_UPDATE(state, truckId) {
    let Truck = state.trucks.find(function(truck) {
      return truck.id === truckId;
    });
    state.systemTruck = Truck;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/trucks/mutations.js